import { Action } from '@ngrx/store';

export enum IsCallCenterActionTypes {
    Set = '[CallCenter] Set',
    Reset = '[CallCenter] Reset',
}

// Action to set the call center flag
export class SetIsCallCenter implements Action {
    readonly type = IsCallCenterActionTypes.Set;
}

// Action to reset the call center flag
export class ResetIsCallCenter implements Action {
    readonly type = IsCallCenterActionTypes.Reset;
}

// Export all actions
export type IsCallCenterActions = SetIsCallCenter | ResetIsCallCenter;
